
/**
 * コーディネイトの掲載商品周り
 * 
 */

let text_soldout = ' Sold Out'

//商品HTMLのエレメントオブジェクト
let el_target_item = document.querySelectorAll('.cellec-sns-product')
let ob_el_target_item = {}
el_target_item.forEach(el=>{
    let handle = el.dataset.item_code
    ob_el_target_item[handle] = el
})
//console.log(ob_el_target_item)

document.addEventListener('DOMContentLoaded',()=>{
    console.log('Ready')
    
    //各商品のバリエーション選択を付加
    set_sns_items_cart()


    //デフォルトSKUを選択
    set_sns_items_default_sku()


    //モーダルの閉じるボタンのイベントリスナ
    let el_modal = document.getElementById('js-modal')
    let els_btn_modal_close = document.querySelectorAll('.js-modal-close')
    els_btn_modal_close.forEach(el=>{
        el.addEventListener('click',()=>{
            el_modal.classList.remove('active')
        })
    })

    //イベントリスナ カートボタン
    let el_cart_btn = document.querySelector('.cellec-sns-main__box__meta__btn-cart')
    el_cart_btn.addEventListener('click',()=>{
        click_cart_btn()
    })

    //イベントリスナ サイズ・カラーを選択したとき
    let els_variations = document.querySelectorAll('.cellec-sns-main__box__meta__products__products select')
    els_variations.forEach(el=>{
        el.addEventListener('change',()=>{
            let handle = el.dataset.handle
            change_select(handle)
        })
    })
})

/**
 * 各商品のセレクトボックスとカートにまとめて入れるボタンを描画
 */
function set_sns_items_cart(){
    console.log('set_sns_items_cart()')
    console.log(sns_items)

    //商品をループ
    Object.keys(sns_items).forEach(code=>{
        //console.log(code,'のカートを組み立てます')
        //console.log(sns_items[code].options)

        let html_option = ''

        //各商品HTMLに選択肢を作成
        sns_items[code].options.forEach((option,index1)=>{
            //console.log(option)
            let title = option.title
            let html_temp = `<select class="cellec-sns-product__option" data-handle="${code}" data-title="${title}">`
            html_temp += `<option value="noselected">${title}を選択</option>`
            option.options.forEach((op,index2) =>{
                html_temp += `<option value="${op}" data-index1="${index1}" data-index2="${index2}">${op}</option>`
            })        
            html_temp += '</select>'

            html_option += html_temp
        })

        //HTMLに各UIを追加
        let el_product_option_selectors_box = ob_el_target_item[code].querySelector('.cellec-sns-product__selectors')
        el_product_option_selectors_box.innerHTML += html_option

        //個別カートボタンを作成・追加
        let html_individual_btn_cart = `<button class="btn btn--secondary btn--full cellec-sns-product__btn-cart-btn" data-handle="${code}" disabled>選択してください</button>`
        let el_product_btn_cart_box = ob_el_target_item[code].querySelector('.cellec-sns-product__btn-cart')
        el_product_btn_cart_box.innerHTML = html_individual_btn_cart

        //個別カートボタンにイベントリスナを付加
        el_product_btn_cart_box.querySelector('button').addEventListener('click',()=>{
            click_individual_cart_btn(code)
        })

        //売り切れの場合、soldoout表示にする
        set_soldout_text(code)
    })

    //カート入れるボタンを作成・追加
    let html_btn_cart = '<button class="btn" disabled>商品を選択してください</button>'
    let el_btn_cart = document.querySelector('.cellec-sns-main__box__meta__btn-cart')
    el_btn_cart.innerHTML += html_btn_cart
}



/**
 * SOLD OUTを判定し、HTMLに付加
 */
function set_soldout_text(handle){
    //console.log(`set_soldout_text(${handle})`)

    let els_select = ob_el_target_item[handle].querySelectorAll('select')

    //オプションが1つの場合
    if(els_select.length==1){
        //console.log('optionは1つ')
        Array.from(els_select[0].options).forEach(el=>{
            //console.log(el)
            sns_items[handle].sku.forEach(sku=>{
                if(sku.option1 == el.value && sku.inventory_quantity == 0){
                    el.textContent = el.value + text_soldout
                }
            })
        })
    }

    //オプションが2つの場合
    if(els_select.length == 2){
        //console.log('optionは2つ')
        let option1 = els_select[0].value //カラー名
        //console.log(option1,'の各サイズを探索')

        Array.from(els_select[1].options).forEach(el=>{
            //console.log(el.value)
            //その商品の全SKUをループ
            sns_items[handle].sku.forEach(sku=>{
                if(option1 == sku.option1 && el.value == sku.option2){
                    //console.log(sku.option1,sku.option2,sku.inventory_quantity)
                    if(sku.inventory_quantity <= 0){
                        el.textContent = el.value + text_soldout
                    }else{
                        if(el.value != 'noselected'){
                            el.textContent = el.value
                        } 
                    }
                }
            })
        })
    }
}

/**
 * カートボタンをクリックしたとき
 */
function click_cart_btn(){
    console.log('click_cart_btn()')

    let arr_cartin_item = []

    //全商品をループ
    el_target_item.forEach(el=>{
        //console.log(el)

        let handle = el.dataset.item_code

        //セレクトされているオプションを確定
        let el_selectbox = el.querySelectorAll('select')
        let flg_selected = true
        let options = []

        el_selectbox.forEach(selectbox=>{
            //console.log(selectbox.value)
            if(selectbox.value == 'noselected'){
                flg_selected = false
            }else{
                options.push(selectbox.value)
            }
        })
        if(flg_selected == true){
            //オプションIDを取得して、配列に格納
            //console.log(el.dataset.item_code,options)

            if(options.length==1){
                //console.log('オプションは1つです')
                sns_items[handle].sku.forEach(sku=>{
                    if(sku.option1 == options[0]){
                        arr_cartin_item.push({
                            id:sku.id,
                            quantity:1
                        })
                    }
                })
            }

            if(options.length==2){
                //console.log('オプションは2つです')
                sns_items[handle].sku.forEach(sku=>{
                    if(sku.option1 == options[0] && sku.option2 == options[1]){
                        arr_cartin_item.push({
                            id:sku.id,
                            quantity:1
                        })
                    }
                })
            }
        }
    })

    let json_cart_items = {
        items:arr_cartin_item
    }
    console.log(json_cart_items)

    //cart.jsでカートに入れる
    let req_data = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(json_cart_items)
    }
    //console.log(req_data)
    fetch('/cart/add.js', req_data)
      .then(response => response.json())
      .then(data => {
        console.log('カートに追加成功:', data);
        if(data.status == 422){
            alert(`【カートに入れられませんでした】\n${data.message}`)
        }else{
            view_modal_cartin_items(data)
        }
      })
      .catch(error => {
        console.error('エラー:', error);
        
      });
      
}

/**
 * 個別のカートボタンをクリックしたとき
 */
function click_individual_cart_btn(handle){
    console.log(`click_individual_cart_btn(${handle})`)

    let selected_skudata = get_selected_skudata(handle)
    if(selected_skudata == false) return

    let json_cart_items = {
        items: [{
            id: selected_skudata.id,
            quantity: 1
        }]
    }
    console.log(json_cart_items)

    //cart.jsでカートに入れる
    let req_data = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(json_cart_items)
    }

    fetch('/cart/add.js', req_data)
      .then(response => response.json())
      .then(data => {
        console.log('カートに追加成功:', data);
        if(data.status == 422){
            alert(`【カートに入れられませんでした】\n${data.message}`)
        }else{
            view_modal_cartin_items(data)
        }
      })
      .catch(error => {
        console.error('エラー:', error);
      });
}

/**
 * オプションのセレクトボックスを変更したとき
 */
function change_select(handle){
    //console.log(`change_select(${handle})`)
    
    //画像を入れ替える
    let el_image = ob_el_target_item[handle].querySelector('.cellec-sns-product__link img')
    let img_url_default = sns_items[handle].image_default
    let img_url = img_url_default
    let el_selectbox = ob_el_target_item[handle].querySelectorAll('select')
    el_selectbox.forEach(el=>{
        if(el.value != 'noselected'){
            sns_items[handle].sku.forEach(sku=>{
                if(sku.image != '' && sku.option1 == el.value){
                    img_url = sku.image
                    //console.log(img_url)
                    el_image.src = '/cdn/shop/' + img_url
                }else{
                    el_image.src = '/cdn/shop/' + img_url
                }
            })
        }
    })

    //納期を記入
    set_sns_items_nouki(handle)

    //SOLDOUTを更新する
    set_soldout_text(handle)

    //選択状況に合わせて個別カートボタンのテキストと有効状態を変える
    let el_individual_btn = ob_el_target_item[handle].querySelector('.cellec-sns-product__btn-cart-btn')
    let flg_individual_selected = true
    let selectboxs = ob_el_target_item[handle].querySelectorAll('select')
    selectboxs.forEach(selectbox=>{
        if(selectbox.value == 'noselected'){
            flg_individual_selected = false
        }
    })

    if(flg_individual_selected){
        let selected_skudata = get_selected_skudata(handle)
        if(selected_skudata && selected_skudata.inventory_quantity > 0){
            el_individual_btn.textContent = 'カートに入れる'
            el_individual_btn.disabled = false
        }else{
            el_individual_btn.textContent = 'Sold Out'
            el_individual_btn.disabled = true
        }
    }else{
        el_individual_btn.textContent = '選択してください'
        el_individual_btn.disabled = true
    }

    //選択状況に合わせてカートボタンのテキストを変える
    let flg_active_incart = false
    el_target_item.forEach(el=>{
        let el_select = el.querySelectorAll('select')
        let flg_temp = true
        
        el_select.forEach(el2=>{
            if(el2.value == 'noselected'){
                flg_temp = false 
            }
        })
        if(flg_temp==true && flg_active_incart==false){
            flg_active_incart = true
        }
    })
    let el_btn_cart = document.querySelector('.cellec-sns-main__box__meta__btn-cart button')
    if(flg_active_incart == true){
        //console.log('まとめて')
        el_btn_cart.textContent = 'まとめてカートに入れる'
        el_btn_cart.disabled = false
    }else{
        //console.log('選択')
        el_btn_cart.textContent = '商品を選択してください'
        el_btn_cart.disabled = true
    }
}


/**
 * カートに入った商品をモーダル表示する
 */
function view_modal_cartin_items(response){
    console.log('view_modal_cartin_items()')
    
    //追加した商品を配列に格納
    let arr_add_item = response.items
    console.log(arr_add_item)

    //追加した商品の情報を取得
    let arr_cartin_item = []
    arr_add_item.forEach(item => {
        let id = item.variant_id
        
        Object.keys(sns_items).forEach(item2=>{
            sns_items[item2].sku.forEach(sku=>{
                if(sku.id == id){
                    //console.log(sku.id)
                    let img_url
                    if(sku.image==''){
                        img_url = sns_items[item2].image_default
                    }else{
                        img_url = sku.image
                    }
                    let ob = {
                        id:id,
                        title:sns_items[item2].title,
                        image:img_url,
                        price:sns_items[item2].price,
                        option1_title:sns_items[item2].options[0].title,
                        option1:sku.option1,
                        option_length:1,
                        option2_title:'',
                        option2:''
                    }
                    if(sns_items[item2].options.length == 1){
                        arr_cartin_item.push(ob)
                    }else{
                        ob['option2_title'] = sns_items[item2].options[1].title
                        ob['option2'] = sku.option2
                        ob['option_length'] = 2
                        arr_cartin_item.push(ob)
                    }
                }
            })
        })
    })
    //console.log(arr_cartin_item)

    //HTMLを生成
    let html = ''
    arr_cartin_item.forEach(d=>{
        html += `
        <div class="cellec-sns-modal-item">
            <div class="cellec-sns-modal-item__image">
                <img src="/cdn/shop/${d.image}" alt="">
            </div>
            <div class="cellec-sns-modal-item__info">
                <p class="cellec-sns-modal-item__title">
                ${d.title}
                </p>
                <div class="cellec-sns-modal-item__options">
                ${d.option1} / ${d.option2}
                </div>
                <div class="cellec-sns-modal-item__price-wrap">
                    ${d.price.toLocaleString()}<small class="cellec-sns-modal-item__price-tani">円(税込)</small>
                </div>
            </div>
        </div>
        `
    })
    //console.log(html)
    let el = document.getElementById('js-sns-modal-items')
    el.innerHTML = html

    //モーダル表示
    let el_modal = document.getElementById('js-modal')
    el_modal.classList.add('active')
}


/**
 * 掲載アイテムのデフォルトSKUを選択
 */
function set_sns_items_default_sku(){
    console.log('set_sns_items_default_sku()')

    let ob_item = {}
            
    //デフォルトSKUの配列をループ
    //console.log(sns_items_default_sku)
    sns_items_default_sku.forEach(sku_default=>{

        //商品をループ
        Object.keys(sns_items).forEach(k=>{
            let tmp_ob = []

            //商品のバリエーションをループ
            sns_items[k].sku.forEach(sku=>{
                if(sku.sku==sku_default){
                    tmp_ob.push(sku.option1,sku.option2)
                    //console.log(tmp_ob)
                }
            })

            if(tmp_ob.length>0){
                ob_item[k]=tmp_ob
            }
        })
    })
    //console.log('ob_item',ob_item)



    //商品のバリエーション選択を変更
    
    //-掲載商品HTMLエレメントをループ
    let els_product = document.querySelectorAll('.cellec-sns-product')
    els_product.forEach(el_product=>{
        let handle = el_product.dataset.item_code
        if(Object.keys(ob_item).indexOf(handle) !== -1){
            //console.log(handle,'をセットします')
            //--セレクトボックスをループ
            let els_selectboxs = el_product.querySelectorAll('select')
            els_selectboxs.forEach(el_selectbox=>{
                //---オプションをループ
                let els_options = el_selectbox.querySelectorAll('option')
                els_options.forEach(el_option=>{
                    //----デフォルトSKUのオブジェクトをループ
                    //console.log(ob_item[handle])
                    ob_item[handle].forEach(d=>{
                        //console.log(el_option.value,d)
                        if(el_option.value==d){
                            el_option.selected = true
                            //console.log(handle,el_option.value,'で一致しました。選択します')
                        }
                    })
                })
            })
            //バリエーション画像・納期を切替
            change_select(handle)
        }
    })
    //console.log('ob_item',ob_item)
}

/**
 * 掲載アイテムの選ばれているSKUの納期を表示
 * 
 * @param {*} handle 
 */
function set_sns_items_nouki(handle){
    //console.log('set_sns_items_nouki()')
    
    let el_target_nouki = ob_el_target_item[handle].querySelector('.cellec-sns-product__nouki')


    let selected_skudata = get_selected_skudata(handle)
    console.log(selected_skudata)
    if(selected_skudata != false){
        let quantity = selected_skudata.inventory_quantity
        let vari_nouki = selected_skudata.nouki
        if(quantity == 0){
            nouki = '在庫なし'
        }else if(vari_nouki != ''){
            nouki = `${vari_nouki}に発送`
        }else{
            nouki = '正午までのご注文で当日発送'
        }
        el_target_nouki.textContent = nouki
    }else{
        el_target_nouki.textContent = ''
    }
}

/**
 * その商品の選択されているオプションのSKUデータを返す。
 * 選択不十分の場合はFalseを返す
 * 
 * @param {*} handle 
 */
function get_selected_skudata(handle){
    //console.log('get_selected_skucode()',handle)

    //商品HTMLエレメントからセレクトボックスを取得しループ
    let selectboxs = ob_el_target_item[handle].querySelectorAll('select')
    let arr_option_selected = []
    selectboxs.forEach(selectbox=>{
        //セレクトボックスからオプションをループ
        arr_option_selected.push(selectbox.value)
    })
    
    //console.log(arr_option_selected)

    //商品JSONから該当のSKUコードを探す
    let result = false
    sns_items[handle].sku.forEach(sku_el=>{
        if(arr_option_selected.length==1 && arr_option_selected[0]==sku_el.option1){
            result = sku_el
        }else if(arr_option_selected.length==2 && arr_option_selected[0]==sku_el.option1 && arr_option_selected[1]==sku_el.option2){
            result = sku_el
        }
    })
    return result
}